module.exports = __webpack_public_path__ + "static/1-9309925673e2bfd726724d958b833574.png";